import axios, {AxiosPromise} from 'axios';

export const GET_REPORT = '/aiReports/getAIReport';
export const GET_REPORT_FOR_EXCEL = '/aiReports/getAIReportForExcel';
export const SAVE_QUERY = '/aiReports/addAIReportFavorite';
export const GET_QUERIES_LIST = '/aiReports/getAIReportsHistory';
export const DELETE_QUERY = '/aiReports/removeAIReportFavorite';

export interface QueryParams {
  pageNumber?: number;
  pageSize?: number;
  [key: string]: any;
}

export interface CancellationHandlers {
  cancelToken?: any;
  signal?: AbortSignal;
  [key: string]: any;
}

export function getReport(
  queryParams: QueryParams,
  cancellationHandlers?: CancellationHandlers
): AxiosPromise<any> {
  return axios.post(GET_REPORT, queryParams, {
    ...cancellationHandlers
  });
}

export function getReportForExcel(reportId: string): AxiosPromise<any> {
  return axios.get(GET_REPORT_FOR_EXCEL, {params: {reportId}});
}

export function saveQuery(reportId: string): AxiosPromise<any> {
  return axios.post(SAVE_QUERY, {reportId});
}

export function getQueriesList(queryParams: QueryParams): AxiosPromise<any> {
  // @ts-ignore
  return axios.get(`${GET_QUERIES_LIST}?isFavorite=true`, queryParams);
}

export function deleteQuery(reportId: string): AxiosPromise<any> {
  return axios.post(DELETE_QUERY, {reportId});
}